import { AHText, Box, Circle, TouchableBox } from "arkh";
import React, { useCallback, useState } from "react";

import { Insets, LayoutChangeEvent, Platform, View } from "react-native";
import * as Haptics from "expo-haptics";
import { useMonths } from "../../../common/useMonths";

export const MonthSelector = (props: {
  selectedMonths: number[];
  onPressMonth(month: number): void;
}) => {
  const months = useMonths("short");
  const renderMonth = useCallback(
    function (month: string, index: number, hitSlop: Insets | undefined) {
      const mId = index + 1;
      return (
        <TouchableBox
          key={index}
          style={{ flex: 1, alignItems: "center" }}
          hitSlop={hitSlop ?? { top: 25, bottom: 35 }}
          onPressIn={() => {
            if (Platform.OS === "ios") {
              Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
            }
          }}
          onPress={() => {
            props.onPressMonth(mId);
          }}
        >
          <Circle
            size="medium"
            color={
              props.selectedMonths.includes(mId)
                ? "status-active"
                : "surface-backgroundControl"
            }
          >
            <AHText
              type="info-small"
              color={
                props.selectedMonths.includes(mId)
                  ? "text-inverted"
                  : "text-primary"
              }
            >
              {month}
            </AHText>
          </Circle>
        </TouchableBox>
      );
    },
    [props]
  );

  const [size, setSize] = useState<"none" | "wrapped" | "regular">("none");
  const onLayout: (event: LayoutChangeEvent) => void = useCallback((e) => {
    setSize(
      e.nativeEvent.layout.width > 400
        ? "regular"
        : e.nativeEvent.layout.width > 1
          ? "wrapped"
          : "none"
    );
  }, []);
  return (
    <View
      style={{
        alignSelf: "stretch",
      }}
      onLayout={onLayout}
    >
      {size === "none" ? null : (
        <>
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            {months
              .slice(0, size === "regular" ? 12 : 6)
              .map((m, i) =>
                renderMonth(
                  m,
                  i,
                  size === "wrapped"
                    ? { top: 20, bottom: 5 }
                    : { top: 20, bottom: 20 }
                )
              )}
          </Box>
          {size === "wrapped" ? (
            <Box
              spaceTop="small"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                flex: 1,
              }}
            >
              {months
                .slice(6, 12)
                .map((m, i) => renderMonth(m, i + 6, { top: 5, bottom: 20 }))}
            </Box>
          ) : null}
        </>
      )}
    </View>
  );
};
